// extracted by mini-css-extract-plugin
export var closeButton = "_kn-2";
export var closeButtonIcon = "_kn-3";
export var lightboxContent = "_kn-1";
export var lightboxOverlay = "_kn-0";